module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('create-target-slot', {
    attrs: {
      "title": _vm.text,
      "overrideLoad": _vm.appendTypeIsNpowerOrComscore,
      "showBackButton": _vm.showBackButton,
      "svg": _vm.svg,
      "png": _vm.png
    }
  }, [(_vm.appendTypeIsNpowerOrComscore) ? [_c('append-n-power-form', {
    staticClass: "upload-modal__upload-options"
  })] : (_vm.showSelectSegment) ? [_c('select-segment-modal', {
    attrs: {
      "slot": "select",
      "onCompleteSegmentUpload": _vm.onComplete,
      "segmentData": _vm.segmentData,
      "uploadedTargetId": _vm.uploadedTargetId,
      "uploadedTargetViewingStream": _vm.uploadedTargetViewingStream
    },
    slot: "select"
  })] : (_vm.showOverwrites) ? [_c('overwrite-form', {
    attrs: {
      "overwrites": _vm.overwrites,
      "onComplete": _vm.onComplete,
      "targetId": _vm.uploadedTargetId
    }
  })] : (_vm.showCreateNewUpload) ? [_c('create-upload', {
    attrs: {
      "defaultSelectedUpload": _vm.defaultSelectedUpload,
      "originalTarget": _vm.originalTarget,
      "onCompleteUpload": _vm.onCompleteUpload,
      "onComplete": _vm.onComplete
    },
    on: {
      "submittedUploadFile": _vm.submittedUploadFile,
      "sentDownstream": _vm.sentDownstream
    }
  })] : (_vm.showAppendNewFile) ? [_c('append-file-uploader', {
    ref: "appendFile",
    attrs: {
      "defaultAppendOption": _vm.defaultAppendingOption,
      "defaultSelectedTarget": _vm.defaultSelectedAppendingTarget,
      "onCompleteUpload": _vm.onCompleteUpload
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5017b535"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/targetSlots/UploadTargetSlot.vue
// module id = 1891
// module chunks = 0